import ApiActions from "../../../actions/ApiActions";
import generatePayload from '../../../helper/generatePayloadForTable'

const getProjectsForAudit = async (skip, limit, sort, search) => {
    let payload = generatePayload(skip, limit, sort, search)
    payload.filterStatus = 'active'
    return await ApiActions.getTeleProjectsForAudit(payload)
}

const getTotalProjects = async (search) => {
    return await ApiActions.getTeleProjectsForAuditCount(search)
}

const getAuditCallersList = async (skip, limit, sort, search, dynamicSearchQuery) => {
    const payload = {skip, limit, sortBy: sort, searchQuery: search || undefined, dynamicSearchQuery}
    return await ApiActions.getAuditCallersList(payload)
}

const getCallsOfCaller = async (skip, limit, sort, search, data) => {
    let payload = generatePayload(skip, limit, sort, search)
    payload = { ...payload, ...data }
    return await ApiActions.getCallsOfCaller(payload)
}

const getLastAuditDate = async (user,teleproject) => {
    const payload = {
        where: {
            "user":user,
            "teleproject":teleproject
        },
        sort: {"createdAt":-1},
        limit: 1
    }
    return await ApiActions.fetchTeletaskHistoryAudits(payload)
}

const getQmfscorerulebook = async (qmfCategory) => {
    return await ApiActions.getQmfscorerulebook(qmfCategory)
}

const getTeletaskCallHistory = async (payload) => {
    return await ApiActions.getTeletaskCallHistory(payload)
}

const getTeleProject = async (teleprojectId) => {
    return await ApiActions.getTeleProject(teleprojectId)
}

const submitQmfScore = async (payload) => {
    return await ApiActions.submitQmfScore(payload)
}

const getQmfCallsAuditReport = async(payload) => {
    return await ApiActions.getQmfCallsAuditReport(payload)
}

const getProjectsForAutohold = async (skip, limit, sort, search) => {
    let payload = generatePayload(skip, limit, sort, search)
    payload.filterStatus = 'active'
    return await ApiActions.getTeleprojectsForAutohold(payload)
}

export {
    getProjectsForAudit,
    getTotalProjects,
    getAuditCallersList,
    getCallsOfCaller,
    getQmfscorerulebook,
    getTeletaskCallHistory,
    getTeleProject,
    submitQmfScore,
    getQmfCallsAuditReport,
    getProjectsForAutohold,
    getLastAuditDate
}